module.exports = __webpack_public_path__ + "img/product-brakeshoes-modal.d53eb397.png";